import { useThree } from "@react-three/fiber";
import { Fog } from 'three';

function Scene() {
  const { scene } = useThree();
  scene.fog = new Fog(0x00130A, 5, 50); // Add fog to the scene
}

export default Scene;